export const GaTracking = (function () {
	'use strict';

	let eventData;

	function init() {
		events();
	}

	function events() {
		$('body').on('click', 'a[data-category]', function () {
			let $t = $(this),
				cat = $t.data('category'),
				label = $t.data('label');

			gaClickHandler(cat, label);
		});

		$('body').on('click', 'a[data-ga-shop]', function (e) {
			const attr = $(this).data('ga-shop').split('|')
			const postData = {
				position: attr[0],
				id: attr[1],
				name: attr[2],
				creative: attr[3]
			}
			if (window.ga) {
				ga('ec:addPromo', postData)
			} else {
				console.log('ga shop clicked', postData)
			}
		});
	}

	function gaClickHandler(cat, label) {
		if (gtag) {
			gtag('event', 'click', {
				event_category: cat,
				event_label: label,
			});
		}

		console.warn('Sent a GA event: ', '\n', '-- Category: ' + cat, '\n', '-- Label: ' + label, '\n');
	}

	return {
		init: init,
	};
})();
